import React from "react";

export type ThemeMode = "light" | "dark";

export interface ThemeModeContextType {
	mode: ThemeMode;
	toggleMode: () => void;
}

export const ThemeModeContext = React.createContext<ThemeModeContextType>({
	mode: "light",
	toggleMode: () => {},
});
